'use client'

import {
  DropdownItem,
  DropdownItemSeparator,
} from '@snowball-tech/fractal/dist/src/components/Dropdown'
import {
  UilCommentsAlt as CoachingsIcon,
  UilEditAlt as CreatorSpaceIcon,
  UilUserMd as GlobalAdminIcon,
  UilCog as MaxAdminIcon,
} from '@tooni/iconscout-unicons-react'
import { useSearchParams } from 'next/navigation'

import { Apps, Roles } from '../../enums'
import { getRoleFlags } from '../../helpers/authentication'
import useAppName from '../../hooks/useAppName'
import useTranslations from '../../hooks/useTranslations'
import useUrls from '../../hooks/useUrls'

type Props = {
  role?: Roles
}
export default function AvatarMenuItems({ role = Roles.Member }: Props) {
  const $t = useTranslations()
  const searchParams = useSearchParams()

  const appName = useAppName()
  const URLs = useUrls()
  const { isAdmin, isCoach, isCorrector, isCreator } = getRoleFlags(
    role,
    searchParams,
  )

  const hasCreatorSpaceAccess =
    (isAdmin || isCreator || isCorrector) && appName !== Apps.Creators

  const hasGlobalAdminAccess = isAdmin && appName !== Apps.Igloo
  const hasMaxAdminAccess = isAdmin && appName !== Apps.Max
  const hasCoachingsAccess = (isAdmin || isCoach) && appName !== Apps.Max

  const hasItems =
    hasGlobalAdminAccess ||
    hasCreatorSpaceAccess ||
    hasMaxAdminAccess ||
    hasCoachingsAccess

  return (
    <>
      {hasGlobalAdminAccess && (
        <DropdownItem
          href={URLs.igloo}
          icon={<GlobalAdminIcon />}
          label={$t('header.avatar.menu.admin')}
        />
      )}

      {hasGlobalAdminAccess && hasCreatorSpaceAccess && (
        <DropdownItemSeparator />
      )}

      {hasCreatorSpaceAccess && (
        <DropdownItem
          href={URLs.creators}
          icon={<CreatorSpaceIcon />}
          label={$t('header.avatar.menu.creators')}
        />
      )}

      {(hasGlobalAdminAccess || hasCreatorSpaceAccess) &&
        (hasMaxAdminAccess || hasCoachingsAccess) && <DropdownItemSeparator />}

      {hasMaxAdminAccess && (
        <DropdownItem
          href={`${URLs.max}/back-office/admin`}
          icon={<MaxAdminIcon />}
          label={$t('header.avatar.menu.max_admin')}
        />
      )}

      {hasCoachingsAccess && (
        <DropdownItem
          href={`${URLs.max}/back-office/chat`}
          icon={<CoachingsIcon />}
          label={$t('header.avatar.menu.coachings')}
        />
      )}

      {hasItems && <DropdownItemSeparator />}
    </>
  )
}
